__turbopack_context__.v({
  "isDanger": "StatusLabel-module-scss-module__5gx6Bq__isDanger",
  "isSuccess": "StatusLabel-module-scss-module__5gx6Bq__isSuccess",
  "isWarning": "StatusLabel-module-scss-module__5gx6Bq__isWarning",
  "line-break": "StatusLabel-module-scss-module__5gx6Bq__line-break",
  "statusLabel": "StatusLabel-module-scss-module__5gx6Bq__statusLabel",
  "text-align_center": "StatusLabel-module-scss-module__5gx6Bq__text-align_center",
});
